export default "__VITE_ASSET__C0Cm348E__"